/**
 * Auto-rotation for classiques roller carousel.
 * Advances to next item every X seconds (AUTO_INTERVAL_SEC in code).
 * Loops to first item at end with same transition as between items. Pauses on hover.
 * It was originally created for the classiques SHP carousel made with the roller component.
 * It works with classical rollers we use everywhere in www, but it was designed to work with a single item displayed at a time.
 * Simply add the class js-roller-auto to the roller and the auto will start :
 * {% embed 'module/roller/roller.html.twig' with {
      classes: 'roller-arrow-title carousel-classiques js-roller-auto',
      news_list: carousel,
  } only %}
 */
import { hasClass } from 'common/tools/dom/classes';
import * as events from 'common/tools/dom/events';
import scrollTo from 'common/tools/dom/scrollTo';

const AUTO_INTERVAL_SEC = 3;
const ROLLER_SCROLL_DURATION_MS = 500;
const SELECTOR = '.js-roller-auto';

const startAuto = (rollerEl, intervalMs) => {
  const slider = rollerEl.querySelector('.roller-slider');
  const btnRight = rollerEl.querySelector('.roller-btn.btn-right');

  if (!slider || !btnRight) {
    return null;
  }

  let timerId = null;

  const advance = () => {
    if (hasClass(btnRight, 'disabled')) {
      scrollTo(
        0,
        ROLLER_SCROLL_DURATION_MS,
        false,
        false,
        slider,
        'left',
        slider.scrollLeft
      );
    } else {
      btnRight.click();
    }
  };

  const stop = () => {
    if (timerId !== null) {
      clearInterval(timerId);
      timerId = null;
    }
  };

  const run = () => {
    stop();
    timerId = setInterval(advance, intervalMs);
  };

  const reset = () => {
    stop();
    run();
  };

  run();

  events.on(rollerEl, 'mouseenter', stop);
  events.on(rollerEl, 'mouseleave', run);

  events.on(btnRight, 'click', reset);
  const btnLeft = rollerEl.querySelector('.roller-btn.btn-left');
  if (btnLeft) {
    events.on(btnLeft, 'click', reset);
  }
};

const init = () => {
  const rollers = document.querySelectorAll(SELECTOR);
  const intervalMs = AUTO_INTERVAL_SEC * 1000;
  rollers.forEach(rollerEl => startAuto(rollerEl, intervalMs));
};

export default init;
